import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';

function Header() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            if (offset > 0) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <React.Fragment>
            <nav className={`navbar navbar-expand-lg nav-underline sticky-top bg-white ${scrolled ? 'shadow' : ''}`}>
                <div className="container-fluid">
                    <NavLink to='/' className="navbar-brand">
                        <img src="/imgs/company-logo.webp" alt="CMO Consulting Logo" className="logo" />
                    </NavLink>

                    {/* toggler for medium and small screens */}
                    <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    {/* offcanvas for medium and small screens */}
                    <div className="offcanvas offcanvas-start custom-offcanvas" tabIndex="-1"
                        id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">

                        <div className="offcanvas-header">
                            <h5 className="offcanvas-title" id="offcanvasNavbarLabel"> Menu </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>

                        <div className="offcanvas-body">
                            <ul className="navbar-nav flex-column">
                                <li className="nav-item">
                                    <NavLink to='/' className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}> Home </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to='/expertise' className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}> Expertise </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to='/services' className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}> Services </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to='/projects' className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}> Projects </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to='/about-us' className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}> About Us </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to='/contact' className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}> Contact </NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* standard navbar for large screens */}
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav ms-auto">
                            <li className="nav-item">
                                <NavLink to='/' className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}> Home </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to='/expertise' className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}> Expertise </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to='/services' className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}> Services </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to='/projects' className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}> Projects </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to='/about-us' className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}> About Us </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to='/contact' className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}> Contact </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </React.Fragment>
    );
}

export default Header;
